import { fetchPageData } from "../../fetchPageData"
import Cookies from 'js-cookie';
import { getStorageItem } from "../../helpers/storageManager";

export const fetchAuthenticationV2Module = async() => {
    window.countryCode = window.page_data?.countryCode	
   const authData = getStorageItem('AuthenticationStore')	
   const userStateToken = Cookies.get("userStateToken") || authData?.user?.userState
   let baseUrl = window?.app_data?.appcmsMain?.apiConfig?.apiBaseUrl		
   let endpoint = window?.cachedAPI || `${baseUrl}/graphql`
   let parsedCountryCode = window.page_data?.countryCode || "IN" //(countryCode && countryCode.country && (countryCode.country).toLowerCase()) || ""
   let offset = 0
   let variables = {
     site: (window?.app_data?.site?.siteInternalName) || null,
     device: "WEB",
     includeContent: true,
     moduleLimit: 4,
     moduleOffset: offset,
     languageCode: window?.app_data?.appcmsMain?.languages?.default?.code || "en",
     countryCode: parsedCountryCode,
     userState: authData ? userStateToken : window.btoa(JSON.stringify({ "state": ["loggedOut"] })),
     modules: [],
     platform : 'web_browser',
     path: '/authentication02'
   }
    const data = fetchPageData(variables, endpoint)
    return data
}

export const getRedirectUrl = (user) => {
  const getRedirectUrl1 = user?.subscription?.subscriptionPlanInfo?.planDetails?.map((planDetail) => planDetail?.redirectUrl).filter((redirectUrl) => redirectUrl)
  if(getRedirectUrl1?.length > 0) {
    return getRedirectUrl1?.length > 0 ? getRedirectUrl1[0] : '/'
  }
  const getRedirectUrl2 = user?.subscription?.tveSubscriptions?.planDetails?.map((planDetail) => planDetail?.redirectUrl).filter((redirectUrl) => redirectUrl)
  if(getRedirectUrl2?.length > 0) {
    return getRedirectUrl2?.length > 0 ? getRedirectUrl2[0] : '/'
  }
}

export const getUserPlansAndRedirectUrl = (user, isSubscribed, isTveLoggedIn) => {
  let getUserPlanIds = []
  let redirectUrl = ''

  if (isSubscribed) {
    getUserPlanIds = [user?.subscription?.subscriptionInfo?.planId]
    redirectUrl = getRedirectUrl(user)
  }

  if (isTveLoggedIn) {
    getUserPlanIds = user?.subscription?.tveSubscriptions?.map(plan => plan?.planId)
    redirectUrl = getRedirectUrl(user)
  }

  return { getUserPlanIds, redirectUrl }
}

export const checkNavigationPlans = async (navigation, getUserPlanIds, getRedirectUrl) => {
  const navigationPlansArr = navigation?.navigationPlans || []
  const storedPlanGroupList = localStorage.getItem("planGroupList")
  const planGroupList = storedPlanGroupList ? JSON.parse(storedPlanGroupList) : []
  const redirectUrl =  sessionStorage.getItem("redirectUrl")
  let navigationPlansIdsArr = navigationPlansArr.map((navigationPlan) => (navigationPlan?.planType === "plangroup") ? planGroupList[navigationPlan?.planID] : navigationPlan?.planID
  )
  const navigationPlansIds = navigationPlansIdsArr.flat(Infinity)
  let matchedNavPlansIdsWithUserId = navigationPlansIds?.length > 0 && getUserPlanIds?.length > 0 && getUserPlanIds.map((getUserPlanId) => {
    if(navigationPlansIds.includes(getUserPlanId)){
      redirectUrl ? '' : sessionStorage.setItem("redirectUrl", getRedirectUrl)
      return getUserPlanId
    } else {
      return ''
    }
  })
  
  const isNavPlansIdMatchWithUserId = (matchedNavPlansIdsWithUserId && matchedNavPlansIdsWithUserId.length > 0) ? matchedNavPlansIdsWithUserId?.some((matchedNavPlansIdWithUserId) => matchedNavPlansIdWithUserId) : false
  return isNavPlansIdMatchWithUserId
}

export const redirectPage = () => {
  const getPageUrl = window.location.pathname
  const redirectUrl = sessionStorage.getItem('redirectUrl')
  const alreadyRedirected = sessionStorage.getItem('alreadyRedirected')
  
  if(getPageUrl === redirectUrl) {
    sessionStorage.setItem('alreadyRedirected', 'true')
    return
  }

  if(!alreadyRedirected && redirectUrl && (getPageUrl !== redirectUrl)) {
    sessionStorage.setItem('alreadyRedirected', 'true')
    window.location.href = redirectUrl
  }
}